export default __webpack_public_path__ + "static/media/SackBasicsRolling.823868be.jpg";